"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadMapPng = void 0;
var file_saver_1 = require("file-saver");
var DownloadMapPng = /** @class */ (function () {
    function DownloadMapPng(_map, _textPack, _elementId) {
        if (_elementId === void 0) { _elementId = "placeholder-downloadMapPng"; }
        var _this = this;
        this._map = _map;
        this._textPack = _textPack;
        this._elementId = _elementId;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                _this._element = $("#".concat(_this._elementId));
                _this.initHtml();
                _this.addHandlers();
                _this._initialised = true;
            }
        };
        this.initHtml = function () {
            var html = "\n<div class=\"mb-2\">\n    <button id=\"downloadMapPngButton\"\n            class=\"btn btn-tools\">\n        <i class=\"fas fa-download\"></i>\n        <span>".concat(_this._textPack.downloadPng, "</span>\n    </button>\n</div>");
            _this._element.append(html);
        };
        this.addHandlers = function () {
            var self = _this;
            $('#downloadMapPngButton').on('click', function () {
                self._map.olMap.once('postcompose', function (event) {
                    var mapCanvas = document.createElement('canvas');
                    var size = self._map.olMap.getSize();
                    mapCanvas.width = size[0];
                    mapCanvas.height = size[1];
                    var mapContext = mapCanvas.getContext('2d');
                    Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
                        if (canvas.width > 0) {
                            var opacity = canvas.parentNode.style.opacity;
                            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                            var transform = canvas.style.transform;
                            // Get the transform parameters from the style's transform matrix
                            var matrix = transform
                                .match(/^matrix\(([^\(]*)\)$/)[1]
                                .split(',')
                                .map(Number);
                            // Apply the transform to the export map context
                            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
                            mapContext.drawImage(canvas, 0, 0);
                        }
                    });
                    mapCanvas.toBlob(function (blob) {
                        (0, file_saver_1.saveAs)(blob, 'map.png');
                    });
                });
                self._map.olMap.renderSync();
            });
        };
        this.init();
    }
    return DownloadMapPng;
}());
exports.DownloadMapPng = DownloadMapPng;
//# sourceMappingURL=DownloadMapPng.js.map